import dayjs from 'dayjs';
import { escape } from 'lodash';
import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';

/**
 * Promuove un testo piatto (non HTML) a RichText valido: escapa i caratteri
 * speciali e avvolge ogni riga non vuota in un paragrafo. NON interpreta
 * markdown: la formattazione si applica nell'editor oppure si fornisce già in
 * HTML (es. import CSV con tag).
 */
export function plainTextToRichText(value: string): string {
  const lines = value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map(line => line.trim())
    .filter(line => line !== '');

  if (lines.length === 0) return '';

  return lines.map(line => `<p>${escape(line)}</p>`).join('');
}

/**
 * Promuove a RichText un valore String che può già contenere tag base (es.
 * importato da CSV): preserva i tag forniti e rende espliciti gli a-capo
 * testuali come `<br>`.
 */
export function stringWithTagsToRichText(value: string): string {
  return value.replace(/\r\n?/g, '\n').replace(/\n/g, '<br>');
}

/**
 * Normalizza un singolo valore in base al tipo di colonna.
 * - Date: converte in formato YYYY-MM-DD
 * - RichText: preserva i tag e converte gli a-capo in `<br>`
 * - Altri tipi: ritorna il valore così com'è
 */
export function normalizeColumnValue(value: any, columnType: Datatype): any {
  if (columnType === Datatype.RichText && typeof value === 'string' && value) {
    return stringWithTagsToRichText(value);
  }
  if (columnType === Datatype.Date && value) {
    const date = dayjs(value);
    if (date.isValid()) {
      return date.format('YYYY-MM-DD');
    }
  }
  return value;
}
